/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CaseDocumentView } from './CaseDocumentView';
import type { SimplePatient } from './SimplePatient';
import type { Specimen } from './Specimen';
import type { UserName } from './UserName';

export type CasesWithDocumentView = {
    readonly id?: number;
    /**
     * WPL's accession value
     */
    readonly accession?: string | null;
    /**
     * date/time that we received a WPL order message indicating accessioning was completed
     */
    accession_completed?: string | null;
    active_assignment: UserName;
    readonly case_document_views?: Array<CaseDocumentView>;
    /**
     * Changing this value will NOT modify the collected_date for each specimen.
     */
    collected_date?: string | null;
    readonly created_at?: string;
    readonly finalized_report_id?: number;
    readonly prelim_report_id?: number;
    ordering_doctor: UserName;
    patient: SimplePatient;
    /**
     * Changing this value will NOT modify the received_date for each specimen.
     */
    received_date?: string | null;
    readonly report_id?: number;
    /**
     * case origin, WPL or PW LIS
     */
    source?: CasesWithDocumentView.source;
    specimens: Array<Specimen>;
}

export namespace CasesWithDocumentView {

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
    }


}
